import React, { FC } from 'react';
import { Flex } from '@edreamsodigeo/prisma-design-system';
import { usePrime } from 'clientState/providers/PrimeProvider';
import TicketsLeftRibbon from '../TicketsLefRibbon';
import { LayoutProps } from '../types';
import { ThreeColumnsItineraryLayoutWrapper } from '@components/Results/Components/ThreeColumnsItinerary/ThreeColumnsItineraryLayout/ThreeColumnsItineraryLayoutWrapper/ThreeColumnsItineraryLayoutWrapper';

const ThreeColumnsItineraryLayoutEqualProminence: FC<LayoutProps> = ({
  itinerary,
  isSem,
  hasRetailingTechniques = true,
  PrimeEqualProminenceDualPriceMobile,
  isAlternativeItinerary,
  isAlternativeTopSection,
  hasAlternativeItineraryDecorator,
  isAlternativeItineraryOnModal,
  isSelectedItinerary,
  isUnavailableItinerary,
}) => {
  const { ticketsLeft } = itinerary;
  const { isUK, isPrimeUser, isPrimeSite } = usePrime() || {};
  const withUKStyle =
    isUK && !isPrimeUser && isPrimeSite && !hasAlternativeItineraryDecorator;

  return (
    <Flex flexDirection={'column'}>
      <ThreeColumnsItineraryLayoutWrapper
        itinerary={itinerary}
        isAlternativeTopSection={isAlternativeTopSection}
        withUKStyle={withUKStyle}
        isAlternativeItineraryOnModal={isAlternativeItineraryOnModal}
        isSelectedItinerary={isSelectedItinerary}
        isAlternativeItinerary={isAlternativeItinerary}
        isUnavailableItinerary={isUnavailableItinerary}
        hasRetailingTechniques={hasRetailingTechniques}
        isSem={isSem}
      >
        {hasRetailingTechniques && (
          <TicketsLeftRibbon
            ticketsNumber={ticketsLeft}
            withUKStyle={withUKStyle}
          />
        )}
      </ThreeColumnsItineraryLayoutWrapper>
      <Flex flexDirection={'column'}>
        {PrimeEqualProminenceDualPriceMobile}
      </Flex>
    </Flex>
  );
};

export default ThreeColumnsItineraryLayoutEqualProminence;
